import React, { PureComponent } from 'react';
import { TwitterPicker } from 'react-color';

class ColorPicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: props.selectedColor,
      refreshedPage: true,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.color !== this.props.selectedColor && this.state.refreshedPage) {
      this.setState({ color: this.props.selectedColor });
    }
  }

  handleChangeComplete = (color, event) => {
    this.setState({ color: color.hex, refreshedPage: false });
    this.props.onColorChange(color.hex);
  };

  render() {
    return (
      <TwitterPicker
        color={this.state.color}
        onChangeComplete={this.handleChangeComplete}
        triangle="hide"
        style={{ margin: 'auto' }}
      />
    );
  }
}

export default ColorPicker;
